export const delay = (milliseconds) => new Promise(resolve => {
    setTimeout(() => {
        resolve();
    }, milliseconds);
});
//# sourceMappingURL=delay.js.map